<template>
  <el-dialog :close-on-click-modal="false" :visible="visible" title="定点备案" width="70rem" @close="close">
    <el-row slot="title">
      <el-col class="flex justify_center">
        2505.人员定点备案
        <medicare-card @emit="getMedicareInfo" />
      </el-col>
    </el-row>
    <el-form ref="editor" label-width="9rem" size="small" :rules="rules" label-position="right" :model="entity" @submit.native.prevent style="padding-right:2rem;">
      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item label="人员编号" prop="psn_no">
            <el-input maxlength="30" show-word-limit v-model="entity.psn_no"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="tel">
            <el-input maxlength="50" show-word-limit v-model="entity.tel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系地址" prop="addr">
            <el-input maxlength="200" show-word-limit v-model="entity.addr"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="业务申请类型:" prop="biz_appy_type">
            <dict-select size="small" v-model="entity.biz_appy_type" isMed dict-type="biz_appy_type" placeholder="业务申请类型" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="起止日期" prop="begndate">
            <datetimerange
              :start.sync="entity.begndate"
              :end.sync="entity.enddate"
              endOfYear
              defaultIsToday
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="定点排序号:" prop="fix_srt_no">
            <el-input maxlength="3" show-word-limit v-model="entity.fix_srt_no"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="定点医药机构编号" prop="fixmedins_code">
            <el-input maxlength="12" show-word-limit v-model="entity.fixmedins_code" readonly @focus="meta.showMedHospital=true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="定点医药机构名称" prop="fixmedins_name">
            <el-input maxlength="200" show-word-limit v-model="entity.fixmedins_name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="人员证件类型:" prop="psn_cert_type">
            <dict-select size="small" v-model="entity.psn_cert_type" isMed dict-type="psn_cert_type" placeholder="人员证件类型" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员证件号码" prop="certno">
            <el-input maxlength="50" show-word-limit v-model="entity.certno"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员姓名" prop="psn_name">
            <el-input maxlength="50" show-word-limit v-model="entity.psn_name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="待遇类型:" prop="med_trt_type">
            <el-input maxlength="10" show-word-limit v-model="entity.med_trt_type"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="备注" prop="memo">
            <el-input maxlength="500" show-word-limit v-model="entity.memo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="代办人姓名:" prop="agnter_name">
            <el-input maxlength="50" show-word-limit v-model="entity.agnter_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代办人证件类型" prop="agnter_cert_type">
            <dict-select size="small" v-model="entity.agnter_cert_type" isMed dict-type="psn_cert_type" placeholder="代办人证件类型" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代办人证件号码" prop="agnter_certno">
            <el-input maxlength="50" show-word-limit v-model="entity.agnter_certno"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="代办人联系方式:" prop="agnter_tel">
            <el-input maxlength="30" show-word-limit v-model="entity.agnter_tel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代办人联系地址" prop="agnter_addr">
            <el-input maxlength="200" show-word-limit v-model="entity.agnter_addr"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代办人关系" prop="agnter_rlts">
            <dict-select size="small" v-model="entity.agnter_rlts" isMed dict-type="agnter_rlts" placeholder="代办人关系" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">
        取 消
      </el-button>
      <el-button type="primary" @click="save" :loading="submitLoad">
        确 定
      </el-button>
    </div>
    <hospital-select :visible.sync="meta.showMedHospital" fixmedins-type="1" :fixmedins-name.sync="entity.fixmedins_name" :fixmedins-code.sync="entity.fixmedins_code">
    </hospital-select>
  </el-dialog>
</template>

<script>
import api from '@/common/api';

const medicareCard = () => import(/* webpackChunkName: 'medicareCard' */ '../../components/_medcom/medicareCard');

export default {
  name: 'fixed',
  components: { medicareCard },
  props: {
    visible: { type: Boolean, default: false },
    value: {},
  },
  data () {
    const { hospitalInfo } = this.$store.state;
    const { inputRuleFn, selectRuleFn } = this.$utils;
    return {
      rules: {
        psn_no: inputRuleFn('人员编号'),
        biz_appy_type: selectRuleFn('业务申请类型'),
        begndate: selectRuleFn('日期'),
        enddate: selectRuleFn('日期'),
        fix_srt_no: inputRuleFn('定点排序号'),
        fixmedins_code: inputRuleFn('定点医药机构编号'),
        fixmedins_name: inputRuleFn('定点医药机构名称'),
        psn_cert_type: inputRuleFn('人员证件类型'),
        certno: inputRuleFn('人员证件号码'),
        psn_name: inputRuleFn('人员姓名'),
        med_trt_type: inputRuleFn('待遇类型'),
        tel: [{
          required: false,
          pattern: /^[1]([3-9])[0-9]{5,9}$/,
          message: '格式错误',
          trigger: 'blur'
        }],
      },
      entity: {
        biz_appy_type: '03',
        fix_srt_no: '1',
        fixmedins_code: hospitalInfo.fixmedinsCode, // H44011300660
        fixmedins_name: hospitalInfo.fixmedinsName, // 广东省人民医院
        tel: '',
        addr: '',
        agnter_name: '',
        agnter_cert_type: '',
        agnter_certno: '',
        agnter_tel: '',
        agnter_addr: '',
        agnter_rlts: '',
        memo: '',
        begndate: null,
        enddate: null,
        psn_cert_type: '',
        certno: '',
        psn_name: '',
        psn_no: '',
        age: '',
        brdy: '',
        gend: '',
        naty: '',
        med_trt_type: '110' // 文档里写，固定110
      },
      meta: {
        showMedHospital: false
      },
      medicareVisible: false,
      submitLoad: false,
      header: null // 医保请求体里的header
    }
  },
  created() {
    this.initFn();
  },
  methods: {
    initFn () {
      const { value } = this;
      const { cardInfo } = this.$store.state;
      if (value && value.name) {
        this.entity.psn_no = value.insuranceNo;
        this.entity.psn_name = value.name;
        this.entity.tel = value.phone;
        this.entity.addr = value.address;
        this.entity.psn_cert_type = value.idType === 'SF' ? '01' : value.idType;
        this.entity.certno = value.idNo;
      } else if (cardInfo.psn_no) {
        // 刷卡了
        this.entity.psn_no = cardInfo.psn_no;
        this.entity.psn_name = cardInfo.psn_name;
        this.entity.psn_cert_type = cardInfo.psn_cert_type;
        this.entity.certno = cardInfo.certno;
      }
    },
    close () {
      this.$emit('update:visible', false)
    },
    save () {
      this.$refs.editor.validate().then(valid => {
        this.submitLoad = true;
        api.exec('2505', { data: this.entity }, this.header)
          .then(res => {
            this.$message.success('定点备案成功');
            this.close();
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.message || '接口异常',
              showClose: true,
              duration: 15000
            });
          })
          .finally(() => this.submitLoad = false);
      }).catch((err) => {});
    },
    // 获取刷卡后的数据
    getMedicareInfo(data) {
      // console.log(2424, data, data.baseinfo);
      for (let i in data.baseinfo) {
        this.entity[i] = data.baseinfo[i];
      }
      this.header = data.header;
    }
  }
}
</script>
